import { getRequest, postRequest, putRequest, deleteRequest, patchRequest } from "@/libs/axios";

let base = "/yethan/workOrderReply"

export const workOrderReply = (wid, params)=>{
    return getRequest(`${base}/${wid}/list`, params)
}
export const workOrderReplyAdd = (wid, params)=>{
    return postRequest(`${base}/${wid}`, params)
}